module.exports = __webpack_public_path__ + "img/jiruto-logo.4b95aeb2.png";